import { useEffect, useState } from "react";
import styles from "../Components/ProductList.module.css"
import OrderItem from "../Components/OrderItem";
import Api from "../Components/Api";
import YourOrderSummary from "../Components/YourOrderSummary"

const YourOrders = () =>{       
    const [orderItems, setOrderItems] = useState([]);     
    const orderStatus = 'your order';
    let loggedInId = localStorage.getItem('access') ? localStorage.getItem('user_id') : 0;
    
    useEffect(() => {
        const customer = async () => {
            try {
                const user = await Api.get(`/customer-details/${loggedInId}/`);
                const customerId = user.data[0].id;
                Api.get(`/customer-order/${customerId}`).then((response) => {
                    console.log(response.data)
                    setOrderItems(response.data)
                })
            } catch (error) {
                console.log(`Hello ${error}`);
            }
        }
        customer();

    }, [])
    return <>
        <div className={`col-sm-12 ${styles.mainContainer}`}>
            <div className="container-fluid">
                {/* <div className="col-sm-10">
                    <h5>Your Orders {loggedInId} </h5>
                    <h6>Hi, You have no recent orders</h6>
                </div> */}
                <div className="row">
                    <div className="col-sm-8">
                        <div className="row">
                            <h5>Your orders</h5>
                        </div>
                    </div>                    
                </div>
                {orderItems.length===0 && <h6>Hi, You have no recent orders</h6>}
                { orderItems.map((item) => (                      
                    <div className="row">
                        <div className="col-sm-8">                            
                            <h6>Order# {item.id}, booked on {new Date(item.date).toDateString()}, {item.status==='Open' ? <> {orderStatus} <span className={styles.orderStatusOpendCss}>confirmed</span></> : item.status==='In Progress' ? <>{orderStatus} <span className={styles.orderStatusInProgressCss}>in progress </span></>: item.status==='Order Ready' ? <>{orderStatus} <span className={styles.orderStatusReadyCss}>ready</span></> : item.status==='Dispatched' ? <>{orderStatus} <span className={styles.orderStatusDispatchedCss}>dispatched</span></> : item.status==='Delivered' ? <>{orderStatus} <span className={styles.orderStatusDeliveredCss}>delivered</span></> : item.status==='Cancelled' ? <>{orderStatus} <span className={styles.orderStatusCancelledCss}>cancelled</span></> : ''}</h6> 
                            <div className="card mb-3">
                            {eval(`${item.order_details}`).map((elm) => (
                                <div className="row" key={elm.id}>
                                    <OrderItem key={elm.id} items={elm} />
                                </div>
                            ))}
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <h6>Order summary</h6>
                            <YourOrderSummary key={item.id} item={item} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </>
}
export default YourOrders;